var React = require('react');

function GlassChampagne (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M64.44 221L78 128h100l13.59 93a55.77 55.77 0 0 1-10.26 39.82c-25.64 35.81-81.15 35.65-106.67 0A55.67 55.67 0 0 1 64.44 221z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M216 464h-56V347.7c60.7-15.2 103.3-72 95-135.4L228 27.4A32.07 32.07 0 0 0 196.33 0H59.73A32.07 32.07 0 0 0 28 27.4L1 212.3c-8.3 63.4 34.3 120.2 95 135.4V464H40a40 40 0 0 0-40 40 8 8 0 0 0 8 8h240a8 8 0 0 0 8-8 40 40 0 0 0-40-40zM74.7 260.82A55.67 55.67 0 0 1 64.44 221L87.37 64h81.33l22.93 157a55.77 55.77 0 0 1-10.26 39.82c-25.64 35.81-81.15 35.65-106.67 0z","className":"fa-primary","key":2})]);
}

GlassChampagne.defaultProps = {"viewBox":"0 0 256 512","className":"icon"};

module.exports = GlassChampagne;

GlassChampagne.default = GlassChampagne;
